module.exports = __webpack_public_path__ + "media/images/flags/64/American-Samoa-f83aff6d4a54a6f892c000e14325282d.png";